import { useState, useEffect } from 'react';
import request from '../lib/request';

const usePreference = () => {
  const [preference, setPreference] = useState({});

  useEffect(() => {
    getUserPreference();

    return () => {
      setPreference({});
    };
  }, []);

  const getUserPreference = async () => {
    const { result } = await request.get('/user/preference');
    setPreference(result);
  };

  const updateUserPreference = async (body) => {
    const { result } = await request.put('/user/preference', body);
    setPreference(result);
  };

  return { preference, updateUserPreference };
};

export default usePreference;
